/**
 * Build API parameters for recipients queries
 * Constructs the params object with pagination and optional filters
 */
export const buildRecipientsApiParams = (
    currentPage: number,
    pageSize: number,
    transformedFilters?: string
): { page: number; pageSize: number; filter_array?: string } => {
    const params: { page: number; pageSize: number; filter_array?: string } = {
        page: currentPage,
        pageSize,
    };

    if (transformedFilters) {
        params.filter_array = transformedFilters;
    }

    return params;
};
